import { render, staticRenderFns } from "./SyncPage.vue?vue&type=template&id=6acc4562&"
import script from "./SyncPage.vue?vue&type=script&lang=js&"
export * from "./SyncPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports